import { useDrop } from 'react-dnd';
import { Task } from '../interfaces/Task';

interface TaskDropZoneProps {
    sectionId?: string;
    insertIndex: number;
    onDrop: (taskId: string, targetSectionId?: string, insertIndex?: number) => void;
}

export default function TaskDropZone(props: TaskDropZoneProps) {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: 'task',
        drop: (item: { taskId: string; currentSectionId?: string; task: Task }) => {
            props.onDrop(item.taskId, props.sectionId, props.insertIndex);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [props.sectionId, props.insertIndex, props.onDrop]);

    const dropZoneStyle = {
        height: isOver && canDrop ? '40px' : '8px',
        backgroundColor: isOver && canDrop ? '#e3f2fd' : 'transparent',
        border: isOver && canDrop ? '2px dashed #2196f3' : 'none',
        borderRadius: '4px',
        transition: 'all 0.2s ease',
        margin: '4px 0',
        position: 'relative' as const,
        opacity: isOver && canDrop ? 1 : 0.3,
    };

    return (
        <div ref={drop as any} style={dropZoneStyle}>
            {isOver && canDrop && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#2196f3',
                    fontStyle: 'italic',
                    fontSize: '12px',
                    pointerEvents: 'none',
                    whiteSpace: 'nowrap'
                }}>
                    Drop here
                </div>
            )}
        </div>
    );
}